import React, { useEffect, useState } from "react";
import ButtonToggle from "../../../components/commons/ButtonToggle";
import {
  getPolygonsFromAirport,
  findAirportByIata,
  RATE_TYPES,
} from "./airportRatesUtils";

const RATE_TYPE_LABELS = {
  [RATE_TYPES.DISTANCE]: "Distance Rate",
  [RATE_TYPES.FIXED]: "Fixed Rate",
};

const FleetRateFilters = ({
  airports = [],
  loadingAirports = false,
  defaultAirportCode,
  onChange,
}) => {
  const [selectedAirport, setSelectedAirport] = useState("");
  const [selectedPolygon, setSelectedPolygon] = useState("");
  const [rateType, setRateType] = useState(RATE_TYPES.DISTANCE);
  const [polygons, setPolygons] = useState([]);

  useEffect(() => {
    if (!airports.length) {
      setSelectedAirport("");
      return;
    }

    const defaultCode =
      airports.find((airport) => airport.iata === defaultAirportCode)?.iata ||
      airports[0]?.iata ||
      "";
    setSelectedAirport(defaultCode);
  }, [airports, defaultAirportCode]);

  useEffect(() => {
    if (rateType !== RATE_TYPES.FIXED || !selectedAirport) {
      setPolygons([]);
      setSelectedPolygon("");
      return;
    }

    const airport = findAirportByIata(airports, selectedAirport);
    const polygonList = getPolygonsFromAirport(airport);
    setPolygons(polygonList);
    setSelectedPolygon(polygonList[0]?.id || "");
  }, [rateType, selectedAirport, airports]);

  useEffect(() => {
    const selectedPolygonData = polygons.find(
      (polygon) => polygon.id === selectedPolygon
    );

    onChange?.({
      airportCode: selectedAirport,
      rateType,
      polygonId: rateType === RATE_TYPES.FIXED ? selectedPolygon : null,
      polygonName:
        rateType === RATE_TYPES.FIXED
          ? selectedPolygonData?.name || null
          : null,
    });
  }, [selectedAirport, rateType, selectedPolygon, polygons, onChange]);

  const handleRateTypeToggle = (label) => {
    const type =
      label === RATE_TYPE_LABELS[RATE_TYPES.FIXED]
        ? RATE_TYPES.FIXED
        : RATE_TYPES.DISTANCE;
    setRateType(type);
  };

  const activeToggleLabel = RATE_TYPE_LABELS[rateType];

  return (
    <div className="rate-analysis-fleet-filters">
      <div className="input-field-sm rate-analysis-filter-field">
        <label htmlFor="rate-analysis-airport">Airport</label>
        <select
          id="rate-analysis-airport"
          value={selectedAirport}
          disabled={loadingAirports || airports.length === 0}
          onChange={(e) => setSelectedAirport(e.target.value)}
        >
          {loadingAirports && <option value="">Loading airports...</option>}
          {!loadingAirports && airports.length === 0 && (
            <option value="">No airports found</option>
          )}
          {!loadingAirports &&
            airports.map((airport) => (
              <option key={airport.id} value={airport.iata}>
                {airport.iata} — {airport.name}
              </option>
            ))}
        </select>
      </div>

      <div className="rate-analysis-filter-toggle">
        <label className="rate-analysis-filter-toggle-label">Rate type</label>
        <ButtonToggle
          btnList={[
            RATE_TYPE_LABELS[RATE_TYPES.DISTANCE],
            RATE_TYPE_LABELS[RATE_TYPES.FIXED],
          ]}
          activeToggle={activeToggleLabel}
          setActiveToggle={handleRateTypeToggle}
        />
      </div>

      {rateType === RATE_TYPES.FIXED && (
        <div className="input-field-sm rate-analysis-filter-field">
          <label htmlFor="rate-analysis-polygon">Polygon area</label>
          <select
            id="rate-analysis-polygon"
            value={selectedPolygon}
            disabled={polygons.length === 0}
            onChange={(e) => setSelectedPolygon(e.target.value)}
          >
            {polygons.length === 0 && (
              <option value="">No polygon areas found</option>
            )}
            {polygons.map((polygon) => (
              <option key={polygon.id} value={polygon.id}>
                {polygon.name}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default FleetRateFilters;
